import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  language: localStorage.getItem("greenadminLang")
    ? localStorage.getItem("greenadminLang")
    : "en",
};
const languageReducer = createSlice({
  initialState,
  name: "Language-Changer",
  reducers: {
    change: (state, action) => {
      state.language = action?.payload;
      localStorage.setItem("greenadminLang", action?.payload);
    },
  },
});

export const { change } = languageReducer?.actions;
export default languageReducer?.reducer;
